import React from "react";
import { Button, Card, Stack } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { HousingCandidate, pluralizeCount } from "../../helpers/housingAssignment";
import useApp from "../../utils/useApp";
import RoomAssignmentRow from "./RoomAssignmentRow";

interface FacilityAssignmentCardState {
  facility: any;
  facilities: any[];
  allRooms: any[];
  rooms: any[];
  totalRoomCount: number;
  totalBedCount: number;
  occupiedBedCount: number;
  expanded: boolean;
  onToggleExpanded: any;
  beds: any[];
  housingCandidates: HousingCandidate[];
  housingByCaseId: Map<number, HousingCandidate>;
  possibleOccupants: any[];
  onAssigned: any;
  onPickerOpenChange: any;
  setErrMessage: any;
  setShowToast: any;
  setToastText: any;
  setToastBody: any;
}

const FacilityAssignmentCard = ({
  facility,
  facilities,
  allRooms,
  rooms,
  totalRoomCount,
  totalBedCount,
  occupiedBedCount,
  expanded,
  onToggleExpanded,
  beds,
  housingCandidates,
  housingByCaseId,
  possibleOccupants,
  onAssigned,
  onPickerOpenChange,
  setErrMessage,
  setShowToast,
  setToastText,
  setToastBody,
}: FacilityAssignmentCardState) => {
  const { showMenu }: any = useApp();

  return (
    <Card className="bg-light mb-0">
      <Card.Body className="p-3">
        <Stack
          direction="horizontal"
          gap={3}
          className={expanded ? "sticky-top bg-light py-2 cursor-pointer" : "cursor-pointer"}
          style={expanded ? { top: showMenu ? 252 : 152, zIndex: 2 } : undefined}
          onClick={onToggleExpanded}
        >
          <Button size="sm" variant="light" className="border p-0" style={{ width: 28, height: 28 }}>
            <FontAwesomeIcon
              icon={faChevronDown}
              fontSize={12}
              className="app-primary-color-inverse"
              style={{ transform: expanded ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.18s ease" }}
            />
          </Button>
          <div>
            <div className="small fw-semibold">{facility.name}</div>
            <div className="text-muted small">
              {pluralizeCount(totalRoomCount, "room")} · {pluralizeCount(totalBedCount, "bed")} · {occupiedBedCount} occupied ·{" "}
              {totalBedCount - occupiedBedCount} open
            </div>
          </div>
        </Stack>

        {expanded && (
          <Stack gap={2} className="mt-3">
            {rooms.map((room: any) => (
              <RoomAssignmentRow
                key={room.id}
                room={room}
                facilities={facilities}
                rooms={allRooms}
                beds={beds}
                housingCandidates={housingCandidates}
                housingByCaseId={housingByCaseId}
                possibleOccupants={possibleOccupants}
                onAssigned={onAssigned}
                onPickerOpenChange={onPickerOpenChange}
                setErrMessage={setErrMessage}
                setShowToast={setShowToast}
                setToastText={setToastText}
                setToastBody={setToastBody}
              />
            ))}
          </Stack>
        )}
      </Card.Body>
    </Card>
  );
};

export default FacilityAssignmentCard;
